import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {SimpleLayout} from './containers/simple-layout';
import {AdminLayoutComponent} from './containers/admin-layout';
import {AdminSystemUserGuardService} from "./services/admin-system-user-guard.service";
export const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth/login',
    pathMatch: 'full',
  },
  {
    path: '',
    component: SimpleLayout,
    children: [
      {
        path: 'auth',
        loadChildren: './auth/auth.module#AuthModule'
      }
    ]
  },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [AdminSystemUserGuardService],
    data: {
      title: 'Admin'
    },
    children: [
      {
        path: 'admin',
        loadChildren: './admin-board/admin-board.module#AdminBoardModule'
      }
    ]
  }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app.routing.ts